<template>
  <div>
    <div class="max-resolution">
      <div class="banner page-head flex-box" style="min-height: 100px">
        <div class="w-100">
          <div class="banner-caption text-center">
            <h2 class="features-header-text ml-0 mt-5 text-center">
              Healthcare
            </h2>
            <h4 class="hc-header">
              <strong> Improve Patient Care with Conversational AI</strong>
            </h4>
            <h5 class="w-50 mx-auto hc-subhead">
              A well-designed conversational assistant can reduce the need for
              human intervention in managing appointments by as much as 80%!
            </h5>
          </div>
        </div>
      </div>
    </div>
    <div style="background-color: rgba(236, 243, 255, 0.33)">
      <div class="max-resolution container d-tb">
        <div class="row">
          <div class="col-4 pr-0">
            <div class="list-group my-5 ml-5" id="list-tab" role="tablist">
              <a
                class="list-group-item mb-3 healthcare-tabs-font list-group-item-action active"
                id="list_appointments_list"
                data-toggle="list"
                href="#list-appointments"
                role="tab"
                aria-controls="appointments"
              >
                <img :src="list_appointments_list.current_icon" />
                <span class="pl-3"> Automate Appointments </span></a
              >
              <a
                class="list-group-item my-3 healthcare-tabs-font list-group-item-action"
                id="list_followups_list"
                data-toggle="list"
                href="#list-followups"
                role="tab"
                aria-controls="followups"
              >
                <img :src="list_followups_list.current_icon" />
                <span class="pl-3"> Automated Follow-ups </span>
              </a>
              <a
                class="list-group-item my-3 healthcare-tabs-font list-group-item-action"
                id="list_rescheduling_list"
                data-toggle="list"
                href="#list-rescheduling"
                role="tab"
                aria-controls="rescheduling"
              >
                <img :src="list_rescheduling_list.current_icon" />
                <span class="pl-3"> Rescheduling & Cancellations </span></a
              >
              <a
                class="list-group-item my-3 healthcare-tabs-font list-group-item-action"
                id="list_feedback_list"
                data-toggle="list"
                href="#list-feedback"
                role="tab"
                aria-controls="feedback"
              >
                <img :src="list_feedback_list.current_icon" />
                <span class="pl-3"> Customer Feedback </span></a
              >
              <a
                class="list-group-item my-3 healthcare-tabs-font list-group-item-action"
                id="list_marketing_list"
                data-toggle="list"
                href="#list-marketing"
                role="tab"
                aria-controls="marketing"
              >
                <img :src="list_marketing_list.current_icon" />
                <span class="pl-3"> Social Media Marketing </span></a
              >
              <a
                class="list-group-item my-3 healthcare-tabs-font list-group-item-action"
                id="list_integration_list"
                data-toggle="list"
                href="#list-integration"
                role="tab"
                aria-controls="integration"
              >
                <img :src="list_integration_list.current_icon" />
                <span class="pl-3"> Integration with EMR/EHR </span>
              </a>
            </div>
          </div>
          <div class="col-8 pl-0">
            <div class="tab-content my-5" id="nav-tabContent">
              <div
                class="tab-pane fade show active wgt-bg mr-5 image-bdr text-center"
                id="list-appointments"
                role="tabpanel"
                aria-labelledby="list_appointments_list"
              >
                <img
                  src="@/assets/img/healthcare/AutomateAppointments.svg"
                  alt=""
                  class="p-5"
                />
              </div>
              <div
                class="tab-pane fade wgt-bg mr-5 image-bdr text-center"
                id="list-followups"
                role="tabpanel"
                aria-labelledby="list_followups_list"
              >
                <img
                  src="@/assets/img/healthcare/AutomatedFollowUps.svg"
                  class="p-5"
                  alt=""
                />
              </div>
              <div
                class="tab-pane fade wgt-bg mr-5 image-bdr text-center"
                id="list-rescheduling"
                role="tabpanel"
                aria-labelledby="list_rescheduling_list"
              >
                <img
                  src="@/assets/img/healthcare/ReschedulingAndCancellations.svg"
                  class="p-5"
                  alt=""
                />
              </div>
              <div
                class="tab-pane fade wgt-bg mr-5 image-bdr text-center"
                id="list-feedback"
                role="tabpanel"
                aria-labelledby="list_feedback_list"
              >
                <img
                  src="@/assets/img/healthcare/CustomerFeedback.svg"
                  class="p-5"
                  alt=""
                />
              </div>
              <div
                class="tab-pane fade wgt-bg mr-5 image-bdr text-center"
                id="list-marketing"
                role="tabpanel"
                aria-labelledby="list_marketing_list"
              >
                <img
                  src="@/assets/img/healthcare/SocialMediaMarketing.svg"
                  class="p-5"
                  alt=""
                />
              </div>
              <div
                class="tab-pane fade wgt-bg mr-5 image-bdr text-center"
                id="list-integration"
                role="tabpanel"
                aria-labelledby="list_integration_list"
              >
                <img
                  src="@/assets/img/healthcare/Integrations.png"
                  class="p-5"
                  alt=""
                />
              </div>
            </div>
          </div>
        </div>
      </div>
      <div class="d-mb">
        <!-- <div class="container">
          <div class="row"> -->
        <div class="col-sm-1 text-left px-3 mb-1 mt-3">
          <span
            :class="check_current_slide_mobile('appointment')"
            class="mb-headers dt-border mx-1 p-1"
            @click="current_active_slide_mobile = 'appointment'"
            >Automate Appointments</span
          >
          <span
            :class="check_current_slide_mobile('automated')"
            class="mb-headers dt-border mx-1 p-1"
            @click="current_active_slide_mobile = 'automated'"
            >Automated Follow-Ups</span
          >
        </div>
        <div class="col-sm-1 text-left px-3 my-1">
          <span
            :class="check_current_slide_mobile('reschedule')"
            class="mb-headers dt-border mx-1 p-1"
            @click="current_active_slide_mobile = 'reschedule'"
            >Rescheduling & Cancellations</span
          >
          <span
            :class="check_current_slide_mobile('feedback')"
            class="mb-headers dt-border mx-1 p-1"
            @click="current_active_slide_mobile = 'feedback'"
            >Customer Feedback</span
          >
        </div>
        <div class="col-sm-1 text-left px-3 my-1">
          <span
            :class="check_current_slide_mobile('socialmedia')"
            class="mb-headers dt-border mx-1 p-1"
            @click="current_active_slide_mobile = 'socialmedia'"
            >Social Media Marketing</span
          >
          <span
            :class="check_current_slide_mobile('integration')"
            class="mb-headers dt-border mx-1 p-1"
            @click="current_active_slide_mobile = 'integration'"
            >Integration with EMR/EHR</span
          >
        </div>
        <div class="wgt-bg m-3">
          <img
            src="@/assets/img/healthcare/AutomateAppointments.svg"
            alt=""
            class="p-5"
            v-if="current_active_slide_mobile == 'appointment'"
          />
          <img
            src="@/assets/img/healthcare/AutomatedFollowUps.svg"
            alt=""
            class="p-5"
            v-if="current_active_slide_mobile == 'automated'"
          />
          <img
            src="@/assets/img/healthcare/AutomateAppointments.svg"
            alt=""
            class="p-5"
            v-if="current_active_slide_mobile == 'reschedule'"
          />
          <img
            src="@/assets/img/healthcare/ReschedulingAndCancellations.svg"
            alt=""
            class="p-5"
            v-if="current_active_slide_mobile == 'feedback'"
          />
          <img
            src="@/assets/img/healthcare/CustomerFeedback.svg"
            alt=""
            class="p-5"
            v-if="current_active_slide_mobile == 'socialmedia'"
          />
          <img
            src="@/assets/img/healthcare/Integrations.png"
            alt=""
            class="p-5"
            v-if="current_active_slide_mobile == 'integration'"
          />
        </div>
      </div>
      <!-- <div> -->
    </div>
  </div>
</template>

<script>
import $ from "jquery";
export default {
  name: "Healthcare",
  data() {
    return {
      current_active_slide: "list_appointments_list",
      list_appointments_list: {
        current_icon: require("@/assets/img/healthcare/AutomateAppointmentsActive.svg"),
        active_icon: require("@/assets/img/healthcare/AutomateAppointmentsActive.svg"),
        inactive_icon: require("@/assets/img/healthcare/AutomateAppointmentsInActive.svg"),
      },
      list_followups_list: {
        current_icon: require("@/assets/img/healthcare/AutomatedFollowupsInActive.svg"),
        active_icon: require("@/assets/img/healthcare/AutomatedFollowupsActive.svg"),
        inactive_icon: require("@/assets/img/healthcare/AutomatedFollowupsInActive.svg"),
      },
      list_rescheduling_list: {
        current_icon: require("@/assets/img/healthcare/ReschedulingAndCancellationsInActive.svg"),
        active_icon: require("@/assets/img/healthcare/ReschedulingAndCancellationsActive.svg"),
        inactive_icon: require("@/assets/img/healthcare/ReschedulingAndCancellationsInActive.svg"),
      },
      list_feedback_list: {
        current_icon: require("@/assets/img/healthcare/CustomerFeedbackInActive.svg"),
        active_icon: require("@/assets/img/healthcare/CustomerFeedbackActive.svg"),
        inactive_icon: require("@/assets/img/healthcare/CustomerFeedbackInActive.svg"),
      },
      list_marketing_list: {
        current_icon: require("@/assets/img/healthcare/SocialMediaMarketingInActive.svg"),
        active_icon: require("@/assets/img/healthcare/SocialMediaMarketingActive.svg"),
        inactive_icon: require("@/assets/img/healthcare/SocialMediaMarketingInActive.svg"),
      },
      list_integration_list: {
        current_icon: require("@/assets/img/healthcare/IntegrationsInActive.svg"),
        active_icon: require("@/assets/img/healthcare/IntegrationsActive.svg"),
        inactive_icon: require("@/assets/img/healthcare/IntegrationsInActive.svg"),
      },
      current_active_slide_mobile: "appointment",
    };
  },
  mounted() {
    const vm = this;
    $('a[data-toggle="list"]').on("show.bs.tab", function (e) {
      vm.current_active_slide = e.target.id;
      // console.log(e);
      // console.log(e.target.id) // newly activated tab
      // console.log(e.relatedTarget.id) // previous active tab
    });
    $(".list-group-item").hover(
      function () {
        $(this).trigger("click");
      },
      function () {}
    );
  },
  watch: {
    current_active_slide(newVal, oldVal) {
      this[newVal].current_icon = this[newVal].active_icon;
      this[oldVal].current_icon = this[oldVal].inactive_icon;
    },
  },
  methods: {
    automate_appointments_icon_display(slide_name) {
      return (this[slide_name].current_icon = this[slide_name].active_icon);
    },
    check_current_slide_mobile(slide) {
      if (slide === this.current_active_slide_mobile) {
        return "mobile-active";
      } else {
        return "mobile-inactive";
      }
    },
  },
};
</script>

<style scoped>
.hc-subhead {
  color: #3a3a3a;
  font: normal normal normal 19px/30px Rubik;
}
.hc-header {
  font-family: "RubikMedium";
  font-size: 25px;
  line-height: 29px;
  color: #3a3a3a;
  font-weight: 300;
}
.healthcare-tabs-color-active {
  color: #283677;
}
.healthcare-tabs-color-inactive {
  color: #8a8a8a;
}
.wgt-bg {
  background-color: #ffffff;
  border-radius: 0px 10px 10px 10px;
}
.list-group-item {
  border-right: none;
  padding-left: 1.5rem;
  padding-right: 0.5rem;
}
.list-group-item.active {
  color: #283677;
  background-color: #ffffff;
  border-color: #dcdcdc;
  border-right: none;
  width: 100.4%;
}

.list-group-item-action {
  color: #8a8a8a;
  border-top-left-radius: 10px;
  border-bottom-left-radius: 10px;
}
.list-group-item:first-child {
  border-top-right-radius: 0;
}
.image-bdr {
  border: 1px solid #dcdcdc;
  min-height: 646px;
  max-height: 671px;
}
.image-bdr img {
  max-width: 65%;
  padding-top: 1%;
}
.list-group-item + .list-group-item {
  border-top-width: thin;
}

.healthcare-tabs-font {
  font: normal normal 500 1rem/1.45rem Rubik;
}
.mb-headers {
  font: normal normal 500 0.75rem/1.25rem Rubik;
}

.dt-border {
  border: 0.5px solid #8a8a8a;
  border-radius: 5px;
  color: #8a8a8a;
}

.mobile-inactive {
  border: 0.5px solid #8a8a8a;
  border-radius: 5px;
  color: #8a8a8a;
}
.mobile-active {
  border: 0.5px solid #283677;
  border-radius: 5px;
  color: #283677;
}
.d-mb {
  display: none;
}
@media only screen and (max-width: 600px) {
  /* .healthcare-tabs-font {
    font: normal normal 500 0.79rem/1.45rem Rubik;
  } */
  .d-tb {
    display: none;
  }
  .d-mb {
    display: grid;
  }
  .wgt-bg {
    border-radius: 10px 10px 10px 10px;
  }
  .banner-caption h5 {
    width: 75% !important;
  }
}

/* @media only screen and (min-width: 600px) {
  .healthcare-tabs-font {
    font: normal normal 500 0.79rem/1.45rem Rubik;
  }
} */

/* @media (min-width: 481px) and (max-width: 768px) {
  .healthcare-tabs-font {
    font: normal normal 500 0.70rem/1.45rem Rubik;
  }
}

@media only screen and (min-width: 768px) {
  .healthcare-tabs-font {
    font: normal normal 500 1rem/1.45rem Rubik;
  }
} */
</style>
